export const mockDeadlines = [
  { id: 'd1', title: { ar: 'تسليم المشروع — يوم 20', en: 'Project Deadline — 20th' },
    subtitle: { ar: 'تسليم المشروع', en: 'Project submission' },
    date: { ar: '20 سبتمبر', en: 'Sep 20' } },
  { id: 'd2', title: { ar: 'تحضير الجامعة — قبل يوم 19', en: 'University Prep — Before 19th' },
    subtitle: { ar: 'مراجعة وتحضير', en: 'Preparation and revision' },
    date: { ar: '19 سبتمبر', en: 'Sep 19' } },
  { id: 'd3', title: { ar: 'تصنيفات الجامعات — يوم 13', en: 'University Rankings — 13th' },
    subtitle: { ar: 'مراجعة النتائج', en: 'Check and review results' },
    date: { ar: '13 سبتمبر', en: 'Sep 13' } },
];

export const mockRecents = [
  { id: 'r1', icon: 'ic-play',
    title: { ar: 'استكشفت أهم نتائج الرياضيات', en: 'Explored key findings in Mathematics' },
    time:  { ar: 'من يومين', en: '2 days ago' } },
  { id: 'r2', icon: 'ic-code',
    title: { ar: 'اتعلمت أساسيات HTML', en: 'Learnt HTML basics' },
    time:  { ar: 'من 3 أيام', en: '3 days ago' } },
];

export const mockPerformance = { performancePercent: 70, progressPercent: 12 };
export const mockStreak = { days: 3, active: true };